import { get, put } from 'utils/api';

export const getCommunicationChannels = async (options = {}) => {
  const response = await get('/communication-channels', options);

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};

export const getContactPreferences = async (contactId, options = {}) => {
  const response = await get(
    `/contacts/${contactId}/communication-preferences`,
    options,
  );

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};

export const updateContactPreferences = async (
  { propertyId, contactId, preferences, modifiedBy },
  options = {},
) => {
  const response = await put(
    `/contacts/property/${propertyId}/${contactId}/communication-preferences`,
    {
      preferences,
      modifiedBy,
    },
    options,
  );

  if (response.error) {
    throw new Error(response.error);
  }

  return response;
};
